module.exports = __webpack_public_path__ + "static/media/1.a088e7f9.svg";